/* eslint-disable camelcase -- Firestore alan adları mevcut veri sözleşmesidir. */
import { isContentSearchIndexable } from './seo';

export const CITIES: Record<string, string> = {
  istanbul: 'İstanbul', ankara: 'Ankara', izmir: 'İzmir', antalya: 'Antalya',
  bursa: 'Bursa', adana: 'Adana', gaziantep: 'Gaziantep', konya: 'Konya',
  kayseri: 'Kayseri', mersin: 'Mersin', eskisehir: 'Eskişehir', trabzon: 'Trabzon',
  samsun: 'Samsun', denizli: 'Denizli', adapazari: 'Adapazarı', kocaeli: 'Kocaeli',
  tekirdag: 'Tekirdağ', mugla: 'Muğla', malatya: 'Malatya', erzurum: 'Erzurum',
  adiyaman: 'Adıyaman', afyonkarahisar: 'Afyonkarahisar', agri: 'Ağrı', aksaray: 'Aksaray',
  amasya: 'Amasya', ardahan: 'Ardahan', artvin: 'Artvin', aydin: 'Aydın',
  balikesir: 'Balıkesir', bartin: 'Bartın', batman: 'Batman', bayburt: 'Bayburt',
  bilecik: 'Bilecik', bingol: 'Bingöl', bitlis: 'Bitlis', bolu: 'Bolu', burdur: 'Burdur',
  canakkale: 'Çanakkale', cankiri: 'Çankırı', corum: 'Çorum', diyarbakir: 'Diyarbakır',
  duzce: 'Düzce', edirne: 'Edirne', elazig: 'Elazığ', erzincan: 'Erzincan',
  giresun: 'Giresun', gumushane: 'Gümüşhane', hakkari: 'Hakkari', hatay: 'Hatay',
  igdir: 'Iğdır', isparta: 'Isparta', kahramanmaras: 'Kahramanmaraş', karabuk: 'Karabük',
  karaman: 'Karaman', kars: 'Kars', kastamonu: 'Kastamonu', kilis: 'Kilis',
  kirikkale: 'Kırıkkale', kirklareli: 'Kırklareli', kirsehir: 'Kırşehir', kutahya: 'Kütahya',
  manisa: 'Manisa', mardin: 'Mardin', mus: 'Muş', nevsehir: 'Nevşehir', nigde: 'Niğde',
  ordu: 'Ordu', osmaniye: 'Osmaniye', rize: 'Rize', sakarya: 'Sakarya', sanliurfa: 'Şanlıurfa',
  siirt: 'Siirt', sinop: 'Sinop', sirnak: 'Şırnak', sivas: 'Sivas', tokat: 'Tokat',
  tunceli: 'Tunceli', usak: 'Uşak', van: 'Van', yalova: 'Yalova', yozgat: 'Yozgat', zonguldak: 'Zonguldak',
};

export const cityToSlug = (name: string): string => name.trim().toLocaleLowerCase('tr-TR')
  .replace(/ı/g, 'i').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ş/g, 's')
  .replace(/ö/g, 'o').replace(/ç/g, 'c').replace(/\s+/g, '-').replace(/[^\w-]+/g, '');

type CityContent = { il_ad?: string; aktif_mi?: boolean | number; seo_indeksle?: boolean; lig_tipi?: string };
export const isPublicCityContent = (item: CityContent): boolean =>
  isContentSearchIndexable(item, Boolean(item.aktif_mi)) && item.lig_tipi !== 'ana';

export const availableCitySlugs = (items: CityContent[]): string[] => {
  const populated = new Set(items.filter(isPublicCityContent).map(item => cityToSlug(item.il_ad || '')));
  return Object.keys(CITIES).filter(slug => populated.has(slug));
};
